import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { menuBuilderShoppingListCopy as copy } from 'src/constants/menuBuilderCopy'

const ShoppingListEmptyEducation = ({ venueId }) => (
  <Container>
    <Title>{copy.emptyTitle}</Title>
    <Body>{copy.emptyBody}</Body>

    <WhyCard>
      <WhyTitle>{copy.catalogueHintTitle}</WhyTitle>
      <WhyBody>{copy.catalogueHintBody}</WhyBody>
    </WhyCard>

    <StepsCard>
      {copy.catalogueHintSteps.map((step, index) => (
        <StepRow key={step}>
          <StepNumber>{index + 1}</StepNumber>
          <StepText>{step}</StepText>
        </StepRow>
      ))}
    </StepsCard>

    {venueId ? (
      <CatalogueLink to={`/v/${venueId}/catalogue`}>
        {copy.guidanceBannerCta}
      </CatalogueLink>
    ) : null}
  </Container>
)

const Container = styled.div`
  margin-bottom: 20px;
`

const Title = styled.h4`
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
`

const Body = styled.p`
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #595959;
`

const WhyCard = styled.div`
  background: #f9fff0;
  border: 1px solid rgba(181, 217, 34, 0.45);
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 12px;
`

const WhyTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #3d5c00;
  margin-bottom: 4px;
`

const WhyBody = styled.div`
  font-size: 13px;
  line-height: 1.45;
  color: #3d5c00;
`

const StepsCard = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 12px;
`

const StepRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`

const StepNumber = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #b5d922;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const StepText = styled.div`
  font-size: 13px;
  line-height: 1.45;
  color: #262626;
`

const CatalogueLink = styled(Link)`
  display: inline-block;
  padding: 8px 14px;
  border-radius: 6px;
  background: #b5d922;
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: #1a1a1a;
    opacity: 0.92;
  }
`

export default ShoppingListEmptyEducation
